/**
 * Estrae un messaggio di errore leggibile da un errore Axios/API.
 *
 * Gestisce tutti i formati comuni di risposta errore:
 *  - FastAPI 422: detail = [{type, loc, msg, input, ctx}, ...]
 *  - FastAPI/generico: detail = "stringa messaggio"
 *  - Formato { message: "..." }
 *  - Fetch/AxiosError plain: err.message
 *  - Nessuna response (network error)
 *
 * NON lancia mai eccezioni e NON restituisce mai oggetti/array —
 * garantisce sempre una stringa sicura per essere passata a toast/render React.
 *
 * @param {any} err - errore Axios o simile
 * @param {string} [fallback='Errore imprevisto'] - messaggio se non estraibile
 * @returns {string} messaggio pronto per toast.error()
 */
export function parseApiError(err, fallback = 'Errore imprevisto') {
  if (!err) return fallback;

  // Se è già una stringa la restituisco pulita
  if (typeof err === 'string') return err;

  const data = err?.response?.data;

  // Formato { detail: ... }
  if (data?.detail !== undefined && data?.detail !== null) {
    const d = data.detail;
    // Caso 1: string
    if (typeof d === 'string') return d;
    // Caso 2: array di Pydantic ValidationError
    if (Array.isArray(d)) {
      const messages = d
        .map((item) => {
          if (typeof item === 'string') return item;
          if (item && typeof item === 'object') {
            const loc = Array.isArray(item.loc) ? item.loc.filter(l => l !== 'body').join('.') : '';
            const msg = item.msg || item.message || 'Valore non valido';
            return loc ? `${loc}: ${msg}` : msg;
          }
          return null;
        })
        .filter(Boolean);
      return messages.length > 0 ? messages.join(' · ') : fallback;
    }
    // Caso 3: oggetto singolo con msg
    if (typeof d === 'object') {
      return d.msg || d.message || JSON.stringify(d).substring(0, 200);
    }
  }

  // Formato { message: "..." }
  if (typeof data?.message === 'string') return data.message;

  // Formato { error: "..." }
  if (typeof data?.error === 'string') return data.error;

  // Fallback su err.message (network error, timeout)
  if (typeof err?.message === 'string') return err.message;

  return fallback;
}

export default parseApiError;
